import React, { useState } from 'react';

const SubscriptionCategory = ({ category = '', children }) => {
  const [collapse, setCollapse] = useState(false);

  return (
    <>
      <tr>
        <td colSpan={4} style={{ backgroundColor: 'var(--yellow-0)', cursor: 'pointer' }} onClick={() => setCollapse(!collapse)}>
          <strong>{collapse ?  <i className="fas fa-plus-square" /> : <i className="fas fa-minus-square" />} {category}</strong>
        </td>
      </tr>
      {!collapse && children}
    </>
  );
};

export default SubscriptionCategory;
